import { CrimsonTheme } from "./crimson";
import { DefaultTheme } from "./default";
import { AppTheme, AppThemeNames } from "./types";

export const AppThemes: Record<AppThemeNames, AppTheme> = {
    [AppThemeNames.DEFAULT]: DefaultTheme,
    [AppThemeNames.CRIMSON]: CrimsonTheme,
}